import { render, staticRenderFns } from "./NoGroupOrTeamDashboard.vue?vue&type=template&id=60ac2b30&scoped=true"
import script from "./NoGroupOrTeamDashboard.vue?vue&type=script&lang=js"
export * from "./NoGroupOrTeamDashboard.vue?vue&type=script&lang=js"
import style0 from "./NoGroupOrTeamDashboard.vue?vue&type=style&index=0&id=60ac2b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ac2b30",
  null
  
)

export default component.exports